<div
  class="host-reservation-bar"
  [class.selected]="isSelected"
  [class.related-selected]="isRelatedSelected"
  [style.background-color]="reservation.__reservationBGColor"
  [style.left]="cellWidth * reservation.__index + 2"
  [style.width]="cellWidth * reservation.__nights - 2"
  (click)="onClickReservation.emit()">
  <!-- <ng-template #contentTemplate>
    <div class="content -my-[5px] flex flex-row items-center divide-x divide-gray-400 divide-solid text-[#111112]">
      <div class="item text-center pr-[12px]" (click)="($event.stopPropagation); onClickChangeHouse.emit()">
        {{ 'calendar.pop.change_house' | translate }}
      </div>
      <div class="item text-center px-[12px]" (click)="($event.stopPropagation); onClickExtendStay.emit()">
        {{ 'calendar.pop.extend_stay' | translate }}
      </div>
      <div class="item text-center pl-[12px]" (click)="($event.stopPropagation); onClickCreateTask.emit()">
        {{ 'calendar.pop.new_task' | translate }}
      </div>
    </div>
  </ng-template> -->

  <div *ngIf="isSelected" class="operate-pop order-operate">
    <div class="content">
      <div class="inner">
        <div class="item" (click)="$event.stopPropagation(); onClickChangeHouse.emit()">
          {{ "calendar.pop.change_house" | translate }}
        </div>
        <div class="item" (click)="$event.stopPropagation(); onClickExtendStay.emit()">
          {{ "calendar.pop.extend_stay" | translate }}
        </div>
        <div class="item" (click)="$event.stopPropagation(); onClickCreateTask.emit()">
          {{ "calendar.pop.new_task" | translate }}
        </div>
      </div>
      <div class="arrow"></div>
    </div>
  </div>

  <div class="overflow-hidden">
    <div class="inner-content px-[3px]">
      <span class="name text-[12px]">
        {{ reservation?.client?.name || reservation?.thirdparty_customer?.name }}
      </span>
      <div class="info text-[10px]">
        <span class="platform">{{ reservation.__channelName }}</span>
        <span class="nights"> {{ reservation.__nights }} {{ "word.plural.night" | translate }} </span>
      </div>
    </div>
  </div>
  <img
    class="owe"
    hostI18nImageSwitcher
    [urls]="['/assets/calendar/owe.png', '/assets/calendar/owe_en.png']"
    *ngIf="reservation?.settlement_status === 1" />
  @if (reservation.reservation_tag?.length) {
    <div
      class="absolute -top-[2px] -right-[2px] h-[8px] w-[8px] rounded-tr-[4px] rounded-bl-[4px] bg-[#ffed33] shadow-[-2px_2px_5px_0_#00000035] cursor-pointer"
      nz-popover
      [nzPopoverTitle]="null"
      [nzPopoverContent]="resvTagsTpl"></div>

    <ng-template #resvTagsTpl>
      @for (tag of reservation.reservation_tag; track tag.id) {
        <div class="v4-tag inline-block mr-2" [style.background-color]="tag.color">
          {{ tag.tag_name }}
        </div>
      }
    </ng-template>
  }
  <!-- <img *ngIf="reservation.reservation_tag?.length" src="/assets/calendar/tag.png" class="tag" /> -->
  <div class="reservation-count" *ngIf="reservation.__reservationCount > 1">
    {{ reservation.__reservationCount }}
  </div>
</div>
